export class CredentialTokenOauth implements ICredentialTokenOauth {
    expiresIn: number;
    token: string;
    refreshToken: string;
    creationDate: Date;
    constructor(object: ICredentialTokenOauth) {
        if (object) {
            this.expiresIn = object.expiresIn;
            this.token = object.token;
            this.refreshToken = object.refreshToken;
            this.creationDate = object.creationDate;
        }
    }
    isValidToken(): boolean {
        let ok = false;
        if (this.token && this.refreshToken) {
            ok = true;
        } else if (this.creationDate) {
            let dateCreation = Date.parse(this.creationDate.toString())
            let dateExpires = dateCreation + (this.expiresIn * 1000);
            let dateActually = Date.parse(new Date().toUTCString().replace("GMT", ""));
            ok = dateActually <= dateExpires
        }
        return ok;
    }
}
